import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { CloseButton, Name } from './atoms';
import { CloseSvg } from 'components/icons';

export const PropertyWrapper = styled.div`
  height: 24px;
  padding-left: 5px;
  flex-shrink: 0;
  padding-right: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  background-color: #F3F5F5;
  border-radius: 20px;
  margin-left: 4px;
`;

export default Molecule({
  template: PropertyWrapper,
  type: 'button',
  atoms: [
    {
      component: Name,
      name: 'Name',
      displayValue: ({ name }) => name ?? ''
    },
    {
      component: CloseButton,
      name: 'Close',
      displayValue: ({ }) => CloseSvg({}),
    },
  ]
})